import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export const SectionItem = ({ section, sections }) => {
  const lang = useSelector((state) => state.mainSlice.lang);
  return (
    <Link
      to={"/welcome/section/" + section.slug + "#content"}
      state={{ section, sections }}
      className="card-wrapper d-block"
    >
      <div
        className="image-wrapper"
        style={{
          backgroundImage: `url(${
            process.env.REACT_APP_API_URL + section.image
          })`,
        }}
      ></div>
      <div className="overlay"></div>
      <h4 className="text">
        {lang === "en"
          ? section.name_en
          : lang === "ru"
          ? section.name_ru
          : section.name_tm}
      </h4>
    </Link>
  );
};
